import { render, staticRenderFns } from "./BoardTable.vue?vue&type=template&id=242088ad&scoped=true"
import script from "./BoardTable.vue?vue&type=script&lang=js"
export * from "./BoardTable.vue?vue&type=script&lang=js"
import style0 from "./BoardTable.vue?vue&type=style&index=0&id=242088ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242088ad",
  null
  
)

export default component.exports